import { type SxProps, type Theme } from '@mui/material';

export const covComponentsStyles = {
  navLoader: {
    minWidth: 180,
    minHeight: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as SxProps<Theme>,
  statusWithInfo: (theme: Theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  }),
  statusLabel: {
    lineHeight: 1.1,
  } as SxProps<Theme>,
  statusInfo: (theme: Theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.grey.infoIconGrey,
    cursor: 'help',
    outline: 'none',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '&:focus-visible': {
      color: theme.palette.primary.main,
    },
  }),
  statusTooltipPopper: {
    '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
      left: '18px !important',
      margin: 0,
      transform: 'translateX(0) !important',
    },
  } as SxProps<Theme>,
  statusTooltip: (theme: Theme) => ({
    position: 'relative',
    overflow: 'visible',
    maxWidth: 260,
    padding: theme.spacing(1, 1.25),
    borderRadius: theme.spacing(0.75),
    border: `1px solid ${theme.palette.border.subtle}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.tooltip,
    color: theme.palette.text.primary,
    fontFamily: '"Nunito Sans", sans-serif',
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: '16px',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-8px',
      left: '18px',
      width: 14,
      height: 14,
      backgroundColor: theme.palette.common.white,
      borderTop: `1px solid ${theme.palette.border.subtle}`,
      borderLeft: `1px solid ${theme.palette.border.subtle}`,
      transform: 'rotate(45deg)',
      boxShadow: theme.palette.shadow.tooltipArrow,
      zIndex: -1,
    },
  }),
} as const;


